import { ClientConfig, DEFAULT_CLIENT_CONFIG } from './config.base';
import { navigationRoutes as BaseLinks, RouteParams } from './links.base';

export const CLIENT_CONFIG: ClientConfig = {
  clientName: 'nedtracking',
  ...DEFAULT_CLIENT_CONFIG,
  logo: {
    lightLogo: 'assets/nedtracking/light-logo.png',
    darkLogo: 'assets/nedtracking/dark-logo.png',
    alt: 'Nedtracking',
    width: '138px',
    height: '58px',
    loginPageWidth: '200px',
    loginPageHeight: '60px',
  },
  showCustomLoginPage: true,
  showLandingPage: true,
  landingPageDetails: {
    backgroundImage: {
      src: 'assets/nedtracking/nedtracking_landing.png',
    },
    brandImage: {
      src: 'assets/nedtracking/landing-page-logo.png',
    },
    headerImage: {
      src: 'assets/nedtracking/dark-logo.png',
    },
  },
};
export const navigationRoutes: RouteParams[] = CLIENT_CONFIG.allowedRoutes.map((x) => BaseLinks[x]);
